import { render, staticRenderFns } from "./InjuryTypeForm.vue?vue&type=template&id=15aa76e3&"
import script from "./InjuryTypeForm.vue?vue&type=script&lang=js&"
export * from "./InjuryTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports